import { render } from "./Planos.vue?vue&type=template&id=dba3e296&scoped=true"
import script from "./Planos.vue?vue&type=script&lang=js"
export * from "./Planos.vue?vue&type=script&lang=js"

import "./Planos.vue?vue&type=style&index=0&id=dba3e296&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba3e296"]])

export default __exports__